"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupChatSocketDeleteObservable = void 0;
const Observable_1 = require("../../socket/Observable");
const DomainEvents_1 = require("../../utils/DomainEvents");
class GroupChatSocketDeleteObservable {
    constructor(chatsStorage, organizationUser, hhnStorage) {
        this.chatsStorage = chatsStorage;
        this.hhnStorage = hhnStorage;
        this.organization = organizationUser.getOrganization();
    }
    deleteChatListener(cb, groupType, chatType) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getDeleteChatEventKey)(this.organization.organizationId, chatType), (data) => __awaiter(this, void 0, void 0, function* () {
            this.hhnStorage.chatStorage.removeChatByType(groupType, data.from);
            this.hhnStorage.filteredChatStorage.removeChatByType(groupType, data.from);
            cb(this.chatsStorage.deleteChat(groupType, data.from));
        }));
    }
    // Soft-delete variant for filtered chat lists: marks the chat as deleted so
    // the list position stays stable. Does not touch the detail caches — the
    // normal delete observable already clears those.
    markChatAsDeletedListener(cb, groupType, chatType) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getDeleteChatEventKey)(this.organization.organizationId, chatType), (data) => __awaiter(this, void 0, void 0, function* () {
            cb(this.chatsStorage.markChatAsDeleted(groupType, data.from));
        }));
    }
}
exports.GroupChatSocketDeleteObservable = GroupChatSocketDeleteObservable;
